export const m = { 
  corporate:'superb one company limited',
  homepage: 'homepage',
  hardwareservices: 'Hardware Services',
  softwareservices: 'Software services',
  integratedsystem: '5A',
  aboutus: 'About us',
}


// WEBPACK FOOTER //
// ./src/common/lang/en.js